(function () {
  /* ---------- smooth anchor scrolling, reduced-motion aware ---------- */
  function reduce() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[data-scroll]') : null;
    if (!a || e.defaultPrevented) return;
    var t = document.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- slider: drag, snap, dots ---------- */
  var slider = document.querySelector('[data-slider]');
  var track  = document.querySelector('[data-track]');
  var dotsEl = document.querySelector('[data-dots]');
  if (slider && track && track.children.length) {
    var slides = [].slice.call(track.children);
    var idx = 0, startX = 0, startScroll = 0, dragging = false, moved = false;

    slider.style.overflowX = 'auto';
    slider.style.scrollSnapType = 'x mandatory';
    slider.style.scrollbarWidth = 'none';
    slides.forEach(function (s) { s.style.scrollSnapAlign = 'center'; });

    slides.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to image ' + (i + 1));
      b.addEventListener('click', function () { go(i); });
      dotsEl.appendChild(b);
    });
    var dots = [].slice.call(dotsEl.children);

    function paint() { dots.forEach(function (d, i) { d.classList.toggle('on', i === idx); }); }
    function go(i) {
      idx = Math.max(0, Math.min(slides.length - 1, i));
      slides[idx].scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      paint();
    }
    slider.addEventListener('scroll', function () {
      var mid = slider.scrollLeft + slider.clientWidth / 2, best = 0, bd = Infinity;
      slides.forEach(function (s, i) {
        var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
        if (d < bd) { bd = d; best = i; }
      });
      if (best !== idx) { idx = best; paint(); }
    }, { passive: true });

    slider.addEventListener('pointerdown', function (e) {
      dragging = true; moved = false; startX = e.clientX; startScroll = slider.scrollLeft;
      slider.classList.add('drag');
    });
    slider.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      slider.scrollLeft = startScroll - dx;
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      slider.addEventListener(ev, function () { dragging = false; slider.classList.remove('drag'); });
    });
    slider.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    paint();
  }

  /* ---------- sticky bar ---------- */
  // It only ever scrolls to the offer, so unlike the store's bar it is safe to
  // show from the top of the page. It hides once the offer card is on screen.
  var sticky = document.querySelector('[data-sticky]');
  var claim  = document.getElementById('claim');
  if (sticky && claim && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { sticky.classList.toggle('on', !en.isIntersecting); });
    }, { rootMargin: '-80px 0px -80px 0px' }).observe(claim);
  }

  /* ---------- bump keeps the displayed total honest ---------- */
  // Whatever the page says is due today has to match what the cart will charge.
  // If the bump is on, the today-total moves; the recurring terms do not.
  (function () {
    var card = document.querySelector('[data-base-price]');
    var bump = document.querySelector('[data-bump]');
    var nowEl = document.querySelector('.o-now');
    var stickyEl = document.querySelector('.o-sticky-price strong');
    if (!card || !bump || !nowEl) return;
    var base = parseInt(card.getAttribute('data-base-price'), 10) || 0;
    var add = parseInt(bump.getAttribute('data-bump-price'), 10) || 0;
    function money(c) { return '$' + (c / 100).toFixed(2); }
    var termsEls = [].slice.call(document.querySelectorAll('[data-terms]'));
    function paint() {
      var on = bump.checked;
      var total = base + (on ? add : 0);
      nowEl.textContent = money(total);
      if (stickyEl) stickyEl.textContent = money(total);
      termsEls.forEach(function (el) {
        var t = el.getAttribute(on ? 'data-terms-bump' : 'data-terms-base');
        if (t) el.textContent = t;
      });
    }
    bump.addEventListener('change', paint);
    paint();
  })();

  /* ---------- checkout: replace the cart, never stack lines ---------- */
  var form = document.getElementById('offerForm');
  if (form && window.fetch) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-buy]');
      var lbl = form.querySelector('[data-buy-label]');
      if (btn) { btn.disabled = true; }
      if (lbl) { lbl.textContent = 'Just a moment…'; }
      var main = {
        id: Number(form.querySelector('[name="id"]').value),
        quantity: 1
      };
      var plan = form.querySelector('[name="selling_plan"]').value;
      if (plan) main.selling_plan = Number(plan);

      // Bump is a separate one-time line - it never takes the selling plan.
      var items = [main];
      var bumpEl = document.querySelector('[data-bump]');
      if (bumpEl && bumpEl.checked) {
        items.push({ id: Number(bumpEl.getAttribute('data-bump-variant')), quantity: 1 });
      }
      var body = { items: items };
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          });
        })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = '/checkout'; })
        .catch(function () { form.submit(); });
    });
  }
})();
